import React from 'react'
import './emotiveMessage.scss'

import viveElCole from '../../../assets/images/home/Vivel_el_cole.png'
import premio from '../../../assets/images/award/premio_home-CO.png'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby-link'
import useMediaQuery from '../../../utils/useMediaQuery'
import { kitWin, LOCALE } from '../../../constants/activity-constants'

const EmotiveMessage = ({ isLogged }) => {
  const isMobile = useMediaQuery()
  return (
    <section className="f-section-emotive-message">
      <div className="f-section-emotive-message__wrapper">
        <div className="f-section-emotive-message__content">
          <div className="f-section-emotive-message__title">
            <h2>Conoce el nuevo</h2>
            <img src={viveElCole} />
            {!isMobile && (
              <img src={kitWin[LOCALE]?.kit || kitWin['es-CO'].kit} />
            )}
          </div>
          <div className="f-section-emotive-message__message">
            <div className="f-section-emotive-message__message__txt">
              <p>
                Nos renovamos para darte una divertida experiencia que ahora
                podrás, compartir con tu familia.
              </p>
              <p>
                Ingresa, juega mientras aprendes sobre la pubertad y lo mejor:
              </p>
              {
                LOCALE === 'es-EC' 
                ? <p>¡Y podrás ganar un kit de productos Nosotras!</p>
                : <p>¡Y podrás ganar un kit Nosotras!</p>
              }
            </div>
            {isMobile && (
              <img src={kitWin[LOCALE]?.kit || kitWin['es-CO'].kit} />
            )}

            <div className="f-section-emotive-message__message__button">
              <Button
                color="pink"
                text={isLogged ? 'Ir a las actividades' : 'Participa'}
                action={() => {
                  navigate('actividades')
                  try {
                    window.dataLayer.push({
                      event: 'ga_event',
                      category: 'Vive el Cole :: Home',
                      action: 'Click :: Banner principal',
                      label: isLogged ? 'Ir a las actividades' : 'Participa',
                      value: '',
                    })
                  } catch (error) {
                    console.log('Datalayer error:', error)
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EmotiveMessage
